import { useState } from 'react';
import { Box, Button, Dialog, Stack, Typography } from '@material-ui/core';
// config
import { PLAY_STORE_URL } from '../config';
// hooks
import useLocales from '../hooks/useLocales';
// utils
import track from '../utils/analytics';
import { isAndroidPhone } from '../utils/platform';
//
import Logo from './Logo';

// ----------------------------------------------------------------------

// Hard gate: Android phone users can't use the web app and are sent to the Play Store.
export default function AndroidAppGate() {
  const { translate } = useLocales();
  const [open] = useState(isAndroidPhone);

  const handleDownload = () => {
    track.event('android_app_gate_download');
    window.location.href = PLAY_STORE_URL;
  };

  return (
    <Dialog open={open} fullScreen disableEscapeKeyDown>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          bgcolor: 'background.default',
        }}
      >
        <Stack spacing={3} alignItems="center" sx={{ maxWidth: 360, textAlign: 'center' }}>
          <Logo type="single" sx={{ width: 96, height: 96, '& img': { height: '96px !important' } }} />

          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            {translate('androidAppGate.title')}
          </Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {translate('androidAppGate.subtitle')}
          </Typography>

          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={handleDownload}
            sx={{ borderRadius: 3, py: 1.5, fontWeight: 700, textTransform: 'none' }}
          >
            {translate('androidAppGate.downloadCta')}
          </Button>

          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {translate('androidAppGate.accountNotice')}
          </Typography>
        </Stack>
      </Box>
    </Dialog>
  );
}
